(function () {
  function money(cents) { return '£' + (cents / 100).toFixed(2); }
  function esc(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function card(p) {
    var img  = p.featured_image ? String(p.featured_image) : '';
    var desc = p.body_html ? p.body_html.replace(/<[^>]+>/g, '').trim().slice(0, 120) : '';
    var salePrice = p.compare_at_price && p.compare_at_price > p.price
      ? '<s>' + money(p.compare_at_price) + '</s>' : '';
    var fragrancePC = p._fragrancePC || '';
    return '<div class="cart-community-pick">'
      + (img ? '<div class="cart-community-pick__image"><img src="' + img + '" alt="' + esc(p.title) + '" loading="lazy" width="80" height="80"></div>' : '')
      + '<div class="cart-community-pick__info">'
      + '<h4 class="cart-community-pick__name">' + esc(p.title) + '</h4>'
      + (desc ? '<p class="cart-community-pick__desc">' + esc(desc) + '&hellip;</p>' : '')
      + (fragrancePC ? '<p class="cart-community-pick__fragrance">' + esc(fragrancePC) + '</p>' : '')
      + '<div class="cart-community-pick__footer">'
      + '<span class="cart-community-pick__price">' + money(p.price) + (salePrice ? ' ' + salePrice : '') + '</span>'
      + '<button class="cart-community-pick__atc" data-variant-id="' + p.variants[0].id + '">Add to cart</button>'
      + '</div></div></div>';
  }

  function correctRender(products) {
    var isDesktop = window.innerWidth >= 768;
    var isDrawer  = this.dataset.mode === 'drawer';
    var html = '';

    if (isDesktop && !isDrawer) {
      // Cart page desktop: 3 picks side-by-side + 3 recs side-by-side
      var picks = products.slice(0, 3);
      var recs  = products.slice(3, 6);

      if (picks.length) {
        html += '<div class="cart-community-picks">'
          + '<h3 class="cart-section-heading">Community picks</h3>'
          + '<div class="cart-community-picks__grid">'
          + picks.map(card).join('')
          + '</div></div>';
      }
      if (recs.length) {
        html += '<div class="cart-community-picks cart-community-picks--recs">'
          + '<h3 class="cart-section-heading">Recommended for you</h3>'
          + '<div class="cart-community-picks__grid">'
          + recs.map(card).join('')
          + '</div></div>';
      }

    } else if (isDesktop && isDrawer) {
      // Cart drawer desktop: 1 pick + 3 recs stacked
      var pick = products[0];
      var recs  = products.slice(1, 4);

      if (pick) {
        html += '<div class="cart-community-picks">'
          + '<h3 class="cart-section-heading">Community pick</h3>'
          + card(pick)
          + '</div>';
      }
      if (recs.length) {
        html += '<div class="cart-community-picks cart-community-picks--recs">'
          + '<h3 class="cart-section-heading">Recommended for you</h3>'
          + '<div class="cart-community-picks__stack">'
          + recs.map(card).join('')
          + '</div></div>';
      }

    } else {
      var pick = products[0];
      var recs  = products.slice(1, 4);

      if (pick) {
        html += '<div class="cart-community-picks">'
          + '<h3 class="cart-section-heading">Community pick</h3>'
          + card(pick)
          + '</div>';
      }
      if (recs.length) {
        html += '<div class="cart-community-picks cart-community-picks--recs">'
          + '<h3 class="cart-section-heading">Recommended for you</h3>'
          + '<div class="cart-community-picks__stack">'
          + recs.map(card).join('')
          + '</div></div>';
      }
    }

    this.innerHTML = html;

    var self = this;
    this.querySelectorAll('[data-variant-id]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        self.addToCart(btn.dataset.variantId, btn);
      });
    });
  }

  function fetchMetafields(products) {
    return Promise.all(products.map(function (p) {
      return fetch('/products/' + p.handle + '?view=cart-meta')
        .then(function (r) { return r.text(); })
        .then(function (text) { p._fragrancePC = text.trim(); return p; })
        .catch(function () { return p; });
    }));
  }

  function patchClass() {
    var Cls = customElements.get('cart-recommendations');
    if (Cls) {
      Cls.prototype.render = function (products) {
        var self = this;
        fetchMetafields(products).then(function (enriched) {
          correctRender.call(self, enriched);
        });
      };
      Cls.prototype.addToCart = function (variantId, btn) {
        btn.disabled = true;
        var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        var sections = cart ? cart.getSectionsToRender().map(function (s) { return s.id; }) : [];
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1, sections: sections, sections_url: window.location.pathname })
        })
          .then(function (r) { return r.json(); })
          .then(function (response) {
            if (cart) cart.renderContents(response);
            btn.disabled = false;
          })
          .catch(function () { btn.disabled = false; });
      };
    } else {
      setTimeout(patchClass, 50);
    }
  }

  patchClass();
})();
